import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

const TINTS: Record<string, string> = {
  'text-amber-600': 'bg-amber-50 text-amber-600',
  'text-primary': 'bg-primary/10 text-primary',
  'text-emerald-600': 'bg-emerald-50 text-emerald-600',
  'text-red-600': 'bg-red-50 text-red-600',
};

@Component({
  selector: 'app-dash-stat-card',
  standalone: true,
  imports: [CommonModule],
  host: { class: 'flex flex-col' },
  template: `
    <div class="flex-1 bg-white rounded-3xl p-4 sm:p-5 shadow-sm border border-slate-100 flex flex-col gap-3 min-h-[96px]" [ngClass]="centered() ? 'justify-center' : 'justify-between'">
      <div class="flex items-start justify-between gap-2">
        <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest leading-snug line-clamp-2 break-words min-w-0">{{ label() }}</p>
        <span *ngIf="icon()" class="w-9 h-9 shrink-0 rounded-xl flex items-center justify-center" [ngClass]="tint()">
          <i class="pi" [ngClass]="icon()"></i>
        </span>
      </div>
      <div class="flex items-baseline gap-2">
        <h3 class="text-2xl sm:text-3xl font-black tracking-tight" [ngClass]="valueClass()">{{ value() }}</h3>
        <span *ngIf="hint()" class="text-xs font-semibold text-slate-400 truncate">{{ hint() }}</span>
      </div>
    </div>
  `,
})
export class DashStatCard {
  label = input.required<string>();
  value = input.required<string | number | null | undefined>();
  hint = input<string>('');
  /** For cards stretched by their container: keep the content together instead of pinning the number to the bottom. */
  centered = input<boolean>(false);
  /** PrimeIcons class, e.g. 'pi-calendar'. */
  icon = input<string>('');
  valueClass = input<string>('text-slate-900');
  readonly tint = computed(() => TINTS[this.valueClass()] ?? 'bg-slate-100 text-slate-500');
}
